<template>
    <CardBase border="border-bottom">
      <!-- Header -->
      <div class="d-flex justify-content-between">
        <div class="d-flex align-items-center" :style="{ gap: '12px' }">
            <el-link
                v-if="goBackRoute != null"
                :underline="false"
                :href="goBackRoute"
            >
                <i class="el-icon-back"></i>
                Voltar
            </el-link>

            <div class="d-flex align-items-center">
                <el-tag 
                    v-if="icon" 
                    type="info" 
                    class="mr-2"
                >
                    <i :class="icon"></i>
                </el-tag>
                <h5
                    v-if="title"
                    class="font-weight-semibold mb-0"
                >{{ title }}</h5>
            </div>
        </div>

        <div class="d-flex align-items-center" :style="{ gap: '12px' }">
            <slot name="actions"></slot>
        </div>
      </div>
    </CardBase>
</template>
<script>
    import {
        Link,
    } from 'element-ui'

    import CardBase from './CardBase.vue'

    export default {
        props: {
            title: {
                type: [String, null],
                default: null
            },
            icon: {
                type: [String, null],
                default: 'el-icon-news'
            },
            goBackRoute: {
                type: [String, null],
                default: null,
            }
        },
        components: {
            CardBase,
            [Link.name]: Link
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/_macro/MacroSubHeader.vue